import styled, { keyframes, css } from 'styled-components'
import { VARIANT_TO_RENDER } from '../../constants'

const ModalOpenAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const ModalCloseAnimation = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

export const Overlay = styled.div<{ $isOpened: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(3, 22, 89, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow: hidden;
  ${({ $isOpened }) =>
    $isOpened
      ? css`
          animation: ${ModalOpenAnimation} 0.2s linear forwards;
        `
      : css`
          animation: ${ModalCloseAnimation} 0.2s linear forwards;
        `}
`

export const ModalContainer = styled.div<{ $variant: string }>`
  position: relative;
  max-width: 96rem;
  width: 100%;
  border-radius: 20px;
  margin: 0 5rem;
  background: ${({ $variant }) =>
    $variant === VARIANT_TO_RENDER.STATISTICS
      ? 'linear-gradient(315deg, #F5F7FF 0%, #CED8FD 100%)'
      : 'linear-gradient(90deg, #6B8BFA 0%, #B0C1FC 60.25%)'};

  @media (max-width: 1279px) {
    max-width: 92rem;
  }

  @media (max-width: 999px) {
    max-width: 47.8rem;
  }

  @media (max-width: 767px) {
    background: none;
    margin: 0 2rem;
  }
`

export const ButtonClose = styled.div`
  position: absolute;
  top: 0px;
  right: -5rem;

  @media (max-width: 767px) {
    top: -4rem;
    right: 1rem;
  }
`

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`

export const BackgroundImage = styled.img<{ $variant: string }>`
  position: absolute;
  bottom: 0;
  left: 0;
  height: ${({ $variant }) => ($variant === VARIANT_TO_RENDER.STATISTICS ? '29.6rem' : '25.6rem')};
  z-index: 0;

  @media (max-width: 999px) {
    display: none;
  }
`

export const ModalContent = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 42rem;
  padding: 1rem;
  z-index: 1;
  border-radius: 20px;
  overflow: hidden;

  @media (max-width: 999px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 1rem;
  }
`

export const ColumnLeft = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 767px) {
    display: none;
  }
`

export const ColumnRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem;
  background: white;
  border-radius: 10px;

  @media (max-width: 767px) {
    padding: 1rem;
  }
`

export const ModalTitle = styled.h2<{ $variant: string }>`
  font-family: coolvetica, Arial, Helvetica, sans-serif;
  font-size: 4.2rem;
  line-height: 4.8rem;
  color: ${({ $variant }) => ($variant === VARIANT_TO_RENDER.STATISTICS ? 'black' : 'white')};
  font-weight: 400;
  margin: 0;
  padding: 3rem;

  @media (max-width: 1279px) {
    font-size: 3.6rem;
    line-height: 4.2rem;
  }
`

export const FormBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2rem;
`

export const LabelWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Button = styled.button`
  width: 100%;
  height: 5rem;
  padding: 0 2rem;
  border-radius: 20px;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  line-height: 2rem;
  color: white;
  font-weight: 400;
  border-radius: 5px;
  background: #3a64f8;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #2a54e8;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`

export const Text = styled.p`
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  line-height: 2rem;
  color: #292e3d;
  font-weight: 400;
  margin: 0;
`
